import { Alert, Button, Group } from "@mantine/core";
import { IconAlertTriangle } from "@tabler/icons-react";
import { errorMessage } from "../../lib/axios";

// Inline error panel with a retry button for react-query failures.
export function QueryError({
  error,
  onRetry,
}: {
  error: unknown;
  onRetry?: () => void;
}) {
  return (
    <Alert
      color="red"
      variant="light"
      icon={<IconAlertTriangle size={16} />}
      title="Couldn’t load data"
    >
      <Group justify="space-between" align="center">
        {errorMessage(error)}
        {onRetry && (
          <Button size="xs" variant="white" color="red" onClick={onRetry}>
            Retry
          </Button>
        )}
      </Group>
    </Alert>
  );
}
